<i *ngIf="isShow" class="fa fa-spin fa-spinner me-2"></i>
<div class="chat-container">
  <div class="chat-window" #msgerChat>
    <div *ngFor="let item of chats$ | async; trackBy: trackByFn" class="message" [ngClass]="{'my-message': item.side =='right', 'other-message': item.side =='left'}"  [id]="item.uniqueString">
      
      <ng-container *ngIf="item.type == 'system'; else regularMessage">
        <label>{{item.message}}</label>
      </ng-container>

      <ng-template #regularMessage>
          <div class="message-header">
            <strong>{{ item.name }} </strong> <span>{{ item.time }}</span> <span *ngIf="item.pageUrl" style="padding-left: 10px; cursor: pointer;" (click)="showPageUrl(item)"> <i class="fa fa-link me-2"></i></span>
          </div>
          <div class="message-body" >
            <ng-container *ngIf="item.fileLink; else otherContent">
              <a [href]="item.fileLink" target="_blank"><i class="fa fa-paperclip"></i> {{item.message}}</a>
            </ng-container>
            <ng-template #otherContent>
              <ng-container *ngIf="item.type =='image'; else textContent">
                  <div [innerHTML]="item.message" (click)="openImage($event)"></div>
              </ng-container>
              <ng-template #textContent>
                <div [innerHTML]="item.message"></div>
              </ng-template>
            </ng-template>
          </div>
      </ng-template>
      

      
    </div>
    <i class="fa fa-spin fa-spinner" *ngIf="waitingMessageConfirmation" ></i>
  </div>
  <div class="chat-input" [formGroup]="chatForm" *ngIf="logadoIsResponsavel">
    <input 
      formControlName="message" 
      placeholder="" 
      (keyup.enter)="send()" 
      (paste)="onPaste($event)" 
      autocomplete="off" 
    />
    <!-- Botão de Enviar -->
    <button *ngIf="chatForm.get('message')?.value" class="btn btn-primary icon" (click)="send()">Send</button>
    
    <!-- Botão de Anexar Arquivo -->
    <label *ngIf="!chatForm.get('message')?.value" class="btn btn-secondary icon">
      <i class="fa fa-paperclip"></i>
      <input type="file" hidden (change)="onFileSelected($event)" />
    </label>
  </div>
  <div class="chat-input" *ngIf="!logadoIsResponsavel" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
    <p style="text-align: center; width: 100%;">
       <strong>Somente o operador responsável pode enviar mensagem para o cliente</strong>
    </p>
    <button type="button" class="btn btn-success" 
            style="width: 100%; margin-top: 10px;" 
            data-bs-toggle="modal"
             matTooltip="Você pode solicitar participação no chat"
            (click)="solicitarParticiparChat()">
       Solicitar entrar na conversa do chat
    </button>
 </div>
 
</div>
